import * as signalR from '@aspnet/signalr';

import { TENANT_NAME } from '../store/authorization/constants';

export enum SignalRResponsesEnum {
	Yes = 'Yes',
	No = 'No',
	Ok = 'Ok',
	Cancel = 'Cancel',
	Continue = 'Continue',
}
export class SignalRConnection {
	mainHub: signalR.HubConnection;
	responseHub: signalR.HubConnection;
	transactionId = null as string | null;

	constructor(mainHubName: string) {
		const tenantName = window.localStorage.getItem(TENANT_NAME);
		this.mainHub = new signalR.HubConnectionBuilder()
			.withUrl(`/dmsapi/api/${mainHubName}?tenant=${tenantName}`)
			.configureLogging(signalR.LogLevel.Information)
			.build();
		this.responseHub = new signalR.HubConnectionBuilder()
			.withUrl(`/dmsapi/api/ResponseHub?tenant=${tenantName}`)
			.configureLogging(signalR.LogLevel.Information)
			.build();
	}

	async start() {
		try {
			const isMainConnected = this.mainHub && this.mainHub.state === signalR.HubConnectionState.Connected;
			!isMainConnected && await this.mainHub.start();
			const isResponseConnected = this.responseHub && this.responseHub.state === signalR.HubConnectionState.Connected;
			!isResponseConnected && await this.responseHub.start();
		} catch (err) {
			console.log("errors are there, contact support team");
		}
		return this;
	}

	async stop() {
		try {
			await this.mainHub.stop();
			await this.responseHub.stop();
		} catch (err) {
			console.log("errors are there, contact support team");
		}
		return this;
	}

	public listenTo(eventName: string, callback: (...args: any[]) => void) {
		this.mainHub.on(eventName, (transactionId: string, ...args: any[]) => {
			this.transactionId = transactionId;
			callback(...args);
		});
	}

	public async mainCall(hubName: string, data: any) {
		return this.mainHub.invoke(hubName, data).catch((err: any) => console.log("errors are there, contact support team"));
	}

	public async acknowledgeCall(signal: SignalRResponsesEnum, data?: any) {
		return this.responseHub.invoke('Ack', this.transactionId, signal, data).catch((err: any) => console.log("errors are there, contact support team"));
	}

	public async response(hubName: string, signal: SignalRResponsesEnum, data: any) {
		return this.responseHub.invoke(hubName, this.transactionId, signal, data).catch((err: any) => console.log("errors are there, contact support team"));
	}
}
